import React from 'react';
import { BasisProvider, defaultTheme, Message } from 'basis';
import { StyledBrowserSupport } from './BrowserSupport.styled';
export const BrowserSupport = _ref => {
  let {
    isDisabled
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledBrowserSupport, {
    isDisabled: isDisabled
  }, /*#__PURE__*/React.createElement(BasisProvider, {
    theme: defaultTheme
  }, /*#__PURE__*/React.createElement(Message, {
    severity: "blocking",
    bg: "secondary.lightBlue.t25",
    title: "Uh oh, looks like your browser (Internet Explorer) is out of date.",
    hasBreakpointWidth: true
  }, "While we no longer support it, you can install modern alternatives for a better browsing experience.")));
};